import removeVietnameseTones from '../components/ConvertVie'

const compareLabelMatch = (inputValue: string, option: any) => {
  const sourceLabel = removeVietnameseTones(option.label)
  const targetLabel = removeVietnameseTones(inputValue).trim()
  const pattern = new RegExp(`${targetLabel}`, 'gi')
  return pattern.test(sourceLabel)
}
export default compareLabelMatch
